exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".selRow[data-v-75184f70]{background-color:#fbff94}.rowBoxShadow[data-v-75184f70]{box-shadow:0 -2px 3px rgb(126 72 156/15%)}.tdGradient[data-v-75184f70]{background:linear-gradient(hsla(0,0%,91%,.4),#fff)}.tdGradient2[data-v-75184f70]{background:linear-gradient(hsla(0,0%,91%,.4),#fff,#fff)}.custom-cursor[data-v-75184f70]{cursor:ns-resize}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-75184f70","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/AdminPanel/Components/ListDocInfo/Components/Tab1_ListSanad.vue
// module id = 532
// module chunks = 0